var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "has-background-dark tile-border" },
    [
      _c(
        "DashboardPanel",
        [
          _c(
            "div",
            {
              staticClass:
                "is-flex is-justify-content-center is-align-items-center panel-heading custom-panel-heading",
            },
            [
              _c("p", { staticClass: "ml-auto has-text-white" }, [
                _vm._v("QUOTE STATUS"),
              ]),
              _c(
                "button",
                {
                  staticClass: "button is-small is-info ml-auto",
                  on: { click: _vm.addNew },
                },
                [
                  _c("i", { staticClass: "mdi mdi-plus pr-1 is-size-6" }),
                  _vm._v(" New"),
                ]
              ),
            ]
          ),
          _c("DashboardProgressBar", {
            attrs: {
              "is-loading": _vm.isLoading,
              "initial-color": "#4E8FE8",
              "loading-color": "#0066cc",
            },
          }),
          _vm.quotes
            ? _c(
                "div",
                { staticClass: "has-background-dark tile-border gap-sm" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "panel-block is-flex is-justify-content-space-between custom-panel custom-panel-border pb-3 clickable-panel",
                      class: [
                        {
                          "custom-panel-with-no-chart":
                            _vm.isUninvoicedJobsAndChartDisabled,
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.onClick(_vm.JobStageTypes.ToBeQuoted)
                        },
                      },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "is-flex is-align-items-center" },
                        [_vm._v("To Be Written")]
                      ),
                      _c("DashboardCircularStatus", {
                        attrs: {
                          value: _vm.quotes.quoteToBeWritten,
                          "color-code": "#3291EF",
                          width: "50px",
                          height: "50px",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "panel-block is-flex is-justify-content-space-between custom-panel custom-panel-border pb-3 clickable-panel",
                      class: [
                        {
                          "custom-panel-with-no-chart":
                            _vm.isUninvoicedJobsAndChartDisabled,
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.onClick(_vm.JobStageTypes.AuthorityPending)
                        },
                      },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "is-flex is-align-items-center" },
                        [_vm._v("Pending Authority")]
                      ),
                      _c("DashboardCircularStatus", {
                        attrs: {
                          value: _vm.quotes.pendingAuthority,
                          "color-code": "#3291EF",
                          width: "50px",
                          height: "50px",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "panel-block is-flex is-justify-content-space-between custom-panel custom-panel-border pb-3 clickable-panel",
                      class: [
                        {
                          "custom-panel-with-no-chart":
                            _vm.isUninvoicedJobsAndChartDisabled,
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.onClick(_vm.JobStageTypes.FollowUpRequired)
                        },
                      },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "is-flex is-align-items-center" },
                        [_vm._v("Follow Up Required")]
                      ),
                      _c("DashboardCircularStatus", {
                        attrs: {
                          value: _vm.quotes.followUpRequired,
                          "color-code": "#3291EF",
                          width: "50px",
                          height: "50px",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticClass:
                        "panel-block is-flex is-justify-content-space-between custom-panel custom-panel-border pb-3 clickable-panel",
                      class: [
                        {
                          "custom-panel-with-no-chart":
                            _vm.isUninvoicedJobsAndChartDisabled,
                        },
                      ],
                      on: {
                        click: function ($event) {
                          return _vm.onClick(_vm.JobStageTypes.Authorised)
                        },
                      },
                    },
                    [
                      _c(
                        "p",
                        { staticClass: "is-flex is-align-items-center" },
                        [_vm._v("Authorised")]
                      ),
                      _c("DashboardCircularStatus", {
                        attrs: {
                          value: _vm.quotes.authorised,
                          "color-code": "#3291EF",
                          width: "50px",
                          height: "50px",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }